T.Form.InputEdit = Class(
	/**
	 * @lends {T.Form.InputEdit#}
	 * @extends {T.Form.Base}
	 * @param {T.Form.InputEdit.Par|Object} [par]
	 */
	{
		__NAME: 'T.Form.InputEdit',

		_isSubmitting: false,

		/**
		 * @param {T.Form.InputEdit.Par|Object} [par]
		 * @constructs
		 */
		__construct: function(par){
			par = par || {};
			this.par = par;

			this._doSave = this.par.onSave || D.doNothing;

			this.node = mkE({
				tag: 'div',
				className: 'input-edit',
				els: [
					this._captionNode = mkE({
						tag: 'label',
						className: 'hidden'
					}),
					this._itemNode = mkE({
						tag: 'div',
						className: 'form-control',
						onclick: this._showInput
					}),
					this._getErrorNode(),
					this._getHelpNode()
				]
			});

			this._draw();
			this._par(par);

			if( par.small ){
				addClassName(this.node, 'input-edit-small');
			}
		},

		_draw: function(){
			if( this.par.value || !this.par.canEdit ){
				this._drawValue();
			}else{
				this._drawInput();
			}
		},

		_showInput: function(){
			if( this.par.fullClick && existsClassName(this._itemNode, 'full-click') ){
				this._drawInput(true);
			}
		},

		_drawValue: function(){
			clearNode(this._itemNode);
			if( this.par.fullClick ){
				addClassName(this._itemNode, 'full-click');
			}
			let valueText = mkE({
				tag: 'div',
				className: 'value-text',
				text: this.par.value
			}).append(this._itemNode);
			if( this.par.canEdit ){
				mkE({
					tag: 'a',
					onclick: D.closure(this, function(e){
						D.stopPropagation(e);
						this._drawInput(true);
						return false;
					}),
					text: this.par.editCaption || D.Lang.get('base.edit')
				}).append(valueText);
			}
		},

		_drawInput: function(focus){
			clearNode(this._itemNode);
			if( this.par.fullClick ){
				removeClassName(this._itemNode, 'full-click');
			}
			let attr = {
				placeholder: this.par.placeholder || ''
			};
			O2O(attr, this.par.attr || {});
			mkE({
				tag: 'div',
				className: 'input-container',
				els: [
					{
						tag: 'form',
						els: [
							this._input = mkE({
								tag: 'input',
								type: 'text',
								attr: attr,
								value: this.par.value || ''
							}),
							{
								tag: 'button',
								text: this.par.saveCaption || D.Lang.get('base.save'),
								onclick: this._save
							}
						],
						prop: {
							onsubmit: this._save
						}
					}
				]
			}).append(this._itemNode);
			if( focus === true ){
				this._input.focus();
			}
		},

		_save: function(){
			if( this._isSubmitting ){
				return false;
			}
			this.error('');
			this._isSubmitting = true;
			this._doSave(this._input.value, this._onSave, this._onError);
			return false;
		},

		_onSave: function(value){
			this._isSubmitting = false;
			this.par.value = value;
			this._draw();
		},

		_onError: function(error){
			this._isSubmitting = false;
			this.error(error);
		},

		setValue: function(value){
			this.par.value = value;
			this._draw();
		}
	},
	T.Form.Base
);

/**
 * @class {T.Form.InputEdit.Par}
 * @extends {T.Form.Base.Par}
 */
T.Form.InputEdit.Par = Class(
	/**
	 * @lends {T.Form.InputEdit.Par#}
	 */
	{
		__NAME: 'T.Form.InputEdit.Par',

		type: 'text',
		placeholder: '',
		value: '',
		onSave: D.doNothing,
		canEdit: true,
		editCaption: '',
		saveCaption: '',
		small: false,
		attr: {},
		fullClick: false
	},
	T.Form.Base.Par
);
